import yup from 'utils/yup';

export const initialDailyFlatRateByTotalFormData = {
  date_range: [null, null] as any,
};

export const dailyFlatRateByTotalValidationSchema = yup.object().shape({
  date_range: yup.array().of(yup.string().min(2, 'This is required').required('this is required')),
});
